document.addEventListener('DOMContentLoaded', function () {
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    mobileMenu.style.maxHeight = '0';
    mobileMenu.style.overflow = 'hidden';
    mobileMenu.style.transition = 'max-height 0.3s ease';

    menuToggle.addEventListener('click', function () {
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!open));
      if (open) {
        mobileMenu.style.maxHeight = '0';
        setTimeout(function() { mobileMenu.hidden = true; }, 300);
      } else {
        mobileMenu.hidden = false;
        mobileMenu.style.maxHeight = mobileMenu.scrollHeight + 'px';
      }
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-input');
      input.value = Math.max(1, parseInt(input.value || 1, 10) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.querySelectorAll('[data-qty-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-input');
      input.value = Math.max(0, parseInt(input.value || 1, 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mediaId = thumb.dataset.mediaId;
      const main = document.querySelector('.product-main-media');
      const target = document.querySelector(`[data-media-id="${mediaId}"]`);
      if (target && main) main.innerHTML = target.innerHTML;
    });
  });
});
